import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af487552"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label_div" }
const _hoisted_2 = { class: "price_item" }
const _hoisted_3 = {
  key: 0,
  class: "description"
}
const _hoisted_4 = {
  key: 1,
  class: "description shipping_description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.price_list, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "price_item_div",
      key: 'order_price_item_' + index
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(item.label), 1),
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(item.value) + " ", 1),
        (item.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(item.description), 1))
          : _createCommentVNode("", true),
        (item.shipping_description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(item.shipping_description), 1))
          : _createCommentVNode("", true)
      ])
    ]))
  }), 128))
}